import React, { useEffect } from 'react';

import styled from 'styled-components';
import { useParams } from 'react-router-dom';

import SingleAccessSuccessCard from '../components/SingleAccessSuccessCard';
import SingleAccessNotFoundCard from '../components/SingleAccessNotFoundCard';
import {
  SingleAccessFormStatus,
  useSingleAccessSetupContext,
} from '../context/SingleAccessSetupContext';
import SingleAccessDefaultCard from '../components/SingleAccessDefaultCard';
import SingleAccessSubmittingCard from '../components/SingleAccessSubmittingCard';

export default function SingleAccessSetupView() {
  const { status, setClaimHash, fetchProfile } = useSingleAccessSetupContext();

  const { hash: hashParam } = useParams<{ hash: string }>();

  useEffect(() => {
    setClaimHash(hashParam);
    fetchProfile();
  }, [fetchProfile, hashParam, setClaimHash]);

  return (
    <WrappedSingleAccessSetupView>
      {status === SingleAccessFormStatus.DEFAULT && <SingleAccessDefaultCard />}
      {status === SingleAccessFormStatus.NOT_FOUND && (
        <SingleAccessNotFoundCard />
      )}
      {status === SingleAccessFormStatus.SUBMITTING && (
        <SingleAccessSubmittingCard />
      )}
      {status === SingleAccessFormStatus.SUCCESS && <SingleAccessSuccessCard />}
    </WrappedSingleAccessSetupView>
  );
}

const WrappedSingleAccessSetupView = styled.div`
  max-width: 400px;
  margin: 0 auto;
`;
